export default "__VITE_ASSET__DLao31JP__"